module.exports = __webpack_public_path__ + "media/images/icon__copy-to-clipboard-c8e5072c11e07e13a418cfc4d077d26c.png";